<template>
  <Dialog :commonDialog="personDialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <span v-if="doUpdate">Update</span>
      <span v-else>Add</span>
      <span>&nbsp;Contact Person</span>
    </template>
    <template v-slot:body>
      <v-form
        ref="personForm"
        v-model.trim="formValid"
        lazy-validation
        v-on:submit.stop.prevent="appendContactPerson"
      >
        <v-row v-if="personDialog" class="mx-3">
          <v-col md="4">
            <label class="font-size-16 font-weight-500 required" for="name"
              >Contact Name</label
            >

            <v-text-field
              id="contact_name"
              v-model.trim="contactPerson.name"
              :rules="[
                validateRules.required(contactPerson.name, 'contact name'),
                validateRules.minLength(contactPerson.name, 'contact name', 2),
                validateRules.maxLength(
                  contactPerson.name,
                  'contact name',
                  100
                ),
              ]"
              dense
              filled
              placeholder="Contact Name"
              solo
              flat
              color="cyan"
              class="required-field"
            ></v-text-field>
          </v-col>

          <v-col md="4">
            <label class="font-size-16 font-weight-500" for="email"
              >Email Address</label
            >

            <v-text-field
              id="email"
              v-model.trim="contactPerson.email"
              :rules="[
                validateRules.validEmail(contactPerson.email, 'email'),
                validateRules.minLength(contactPerson.email, 'Email', 2),
                validateRules.maxLength(contactPerson.email, 'email', 100),
              ]"
              dense
              filled
              placeholder="Email Address"
              solo
              flat
              color="cyan"
              class="required-field"
            ></v-text-field>
          </v-col>

          <v-col md="4" class="">
            <label class="font-size-16 font-weight-500 ml-1" for="Designation"
              >Designation</label
            >
            <v-autocomplete
              :items="designations"
              v-model.trim="contactPerson.designation"
              dense.
              filled
              color="cyan"
              item-color="cyan"
              solo
              flat
              append-outer-icon="mdi-cog"
              placeholder="Designation"
              v-on:click:append-outer="manageDesignationDialog = true"
              item-text="text"
              item-value="text"
              class="width-100 new-height"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="'No Designation(s) Found.'"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>

            <template>
              <ManageCustomerdesignation
                :dialog="manageDesignationDialog"
                :e_designation="designations"
                v-on:close-dialog="manageDesignationDialog = false"
                v-on:get-e-designation="setOptions"
              ></ManageCustomerdesignation>
            </template>
          </v-col>

          <v-col md="4">
            <label class="font-size-16 font-weight-500" for="y-primary_phone"
              >Mobile Number</label
            >
            <PhoneTextField
              id="y-phone"
              v-model="contactPerson.phone"
              :phoneKey="1"
              label="Mobile Number"
            >
            </PhoneTextField>
          </v-col>
          <v-col md="4">
            <label class="font-size-16 font-weight-500" for="y-did">
              DID
            </label>
            <PhoneTextField
              id="y-did"
              v-model="contactPerson.did"
              :phoneKey="2"
              label="DID"
            >
            </PhoneTextField>
          </v-col>

          <v-col md="4">
            <label class="font-size-16 font-weight-500" for="y-landline">
              Landline Number
            </label>
            <PhoneTextField
              id="y-did"
              v-model="contactPerson.landline"
              :phoneKey="3"
              label="Landline Number"
            >
            </PhoneTextField>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:action>
      <v-btn
        v-on:click="$emit('close', true)"
        depressed
        class="mx-2 custom-grey-border custom-bold-button"
      >
        Cancel
      </v-btn>
      <v-btn
        class="mx-2 custom-bold-button white--text"
        v-on:click="appendContactPerson"
        color="cyan"
        depressed
        :disabled="!formValid"
      >
        <span v-if="doUpdate">Update</span>

        <span v-else>Add</span>
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import { v4 as uuidv4 } from "uuid";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import Dialog from "@/view/pages/partials/Dialog";
import PhoneTextField from "@/view/pages/partials/PhoneTextField";
import { PUT, GET } from "@/core/services/store/request.module";
import ManageCustomerdesignation from "@/view/pages/partials/Manage-Customerdesignation.vue";
//import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
export default {
  model: {
    prop: "value",
    event: "input",
  },
  mixins: [ValidationMixin, CommonMixin],
  data() {
    return {
      manageDesignationDialog: false,
      designations: [],
      formValid: false,
      contactPersons: [],
      contactPerson: {
        id: null,
        name: null,
        email: null,
        designation: null,
        phone: null,
        did: null,
        landline: null,
        primary: 0,
        will_notified: 1,
      },
    };
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    personDialog: {
      type: Boolean,
      default: false,
    },

    doSave: {
      type: Boolean,
      default: false,
    },
    doUpdate: {
      type: Boolean,
      default: false,
    },
    leadId: {
      type: Number,
      default: 0,
    },

    personId: {
      type: Number,
      default: 0,
    },

    lead: {
      type: Object,
      default: null,
    },

    personUuid: {
      type: String,
      default: null,
    },

    personAlldata: {
      type: Object,
      default: null,
    },

    disableOne: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.contactPersons = cloneDeep(newVal || []);
      },
    },

    personDialog() {
      this.initComponent();
    },

    personAlldata(param) {
      if (param) {
        this.contactPerson = param;
      } else {
        this.contactPerson = {};
      }
    },
  },
  methods: {
    initComponent() {
      const result = this.lodash.cloneDeep(this.value);
      this.contactPersons = result;

      if (this.doUpdate) {
        this.$nextTick(() => {
          let contact_person = this.lodash.find(this.contactPersons, {
            id: this.personId,
          });

          if (!contact_person) {
            contact_person = this.lodash.find(this.contactPersons, {
              uuid: this.personUuid,
            });
          }

          if (contact_person) {
            this.$nextTick(() => {
              this.contactPerson = {
                id: contact_person.id,
                uuid: contact_person.uuid,
                lead: contact_person.lead,
                name: contact_person.name,
                email: contact_person.email,
                designation: contact_person.designation,
                phone: contact_person.phone,
                did: contact_person.did,
                landline: contact_person.landline,
                primary: +contact_person.primary,
                will_notified: +contact_person.will_notified,
              };
            });
          }
        });
      } else {
        this.$nextTick(() => {
          let contactIndex = this.contactPersons.length + 1;
          this.contactPerson = {
            id: null,
            uuid: uuidv4(),
            lead: null,
            name: null,
            email: null,
            designation: null,
            phone: null,
            did: null,
            landline: null,
            primary: 0,
            will_notified: 1,
            contactIndex: contactIndex,
          };
        });
      }
    },

    resetForm() {
      this.contactPerson = {
        id: null,
        uuid: uuidv4(),
        name: null,
        email: null,
        designation: null,
        phone: null,
        did: null,
        landline: null,
        primary: 0,
        will_notified: 1,
      };
      this.formValid = false;
    },
    setOptions() {
      let _this = this;
      _this.$store
        .dispatch(GET, {
          url: "get-customer-designation",
        })
        .then(({ data }) => {
          _this.designations = this.lodash.map(
            data.customer_designation,
            function (row) {
              return {
                text: row.text,
                value: row.id,
              };
            }
          );
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    async appendContactPerson() {
      if (!this.$refs.personForm.validate()) return;
      let contactId = this.contactPerson.id;
      let temp_persons = this.lodash.cloneDeep(this.contactPersons);

      if (!this.disableOne) {
        if (!contactId) {
          if (this.personUuid) {
            let existIndex = this.lodash.findIndex(temp_persons, {
              uuid: this.personUuid,
            });
            if (existIndex >= 0) {
              temp_persons.splice(existIndex, 1, {
                uuid: this.contactPerson.uuid,
                id: this.contactPerson.id,
                name: this.contactPerson.name,
                email: this.contactPerson.email,
                designation: this.contactPerson.designation,
                phone: this.contactPerson.phone,
                did: this.contactPerson.did,
                landline: this.contactPerson.landline,
                primary: this.contactPerson.primary,
                will_notified: this.contactPerson.will_notified,
                contactIndex: this.contactPerson.contactIndex,
              });
            }
          } else {
            temp_persons.push({
              id: this.contactPerson.id,
              uuid: this.contactPerson.uuid,
              name: this.contactPerson.name,
              email: this.contactPerson.email,
              designation: this.contactPerson.designation,
              phone: this.contactPerson.phone,
              did: this.contactPerson.did,
              landline: this.contactPerson.landline,
              primary:
                temp_persons.length === 0 ? 1 : this.contactPerson.primary,
              will_notified: this.contactPerson.will_notified,
              contactIndex: this.contactPerson.contactIndex,
            });
          }

          this.$emit("input", temp_persons);
          this.$emit("update:person", this.contactPerson);
          this.$emit("close", true);
          return false;
        }
      }

      if (!this.contactPerson.contactIndex) {
        this.contactPersons.push({
          id: this.contactPerson.id,
          uuid: this.contactPerson.uuid,
          name: this.contactPerson.name,
          email: this.contactPerson.email,
          designation: this.contactPerson.designation,
          phone: this.contactPerson.phone,
          did: this.contactPerson.did,
          landline: this.contactPerson.landline,
          primary:
            this.contactPersons.length === 0 ? 1 : this.contactPerson.primary,
          will_notified: this.contactPerson.will_notified,
          contactIndex: this.contactPerson.contactIndex,
        });
      } else {
        this.contactPersons[this.contactPerson.contactIndex - 1] = {
          id: this.contactPerson.id,
          uuid: this.contactPerson.uuid,
          name: this.contactPerson.name,
          email: this.contactPerson.email,
          designation: this.contactPerson.designation,
          phone: this.contactPerson.phone,
          did: this.contactPerson.did,
          landline: this.contactPerson.landline,
          primary: this.contactPerson.primary,
          will_notified: this.contactPerson.will_notified,
          contactIndex: this.contactPerson.contactIndex,
        };
      }

      if (this.contactPerson.contactIndex) {
        this.doUpdate = false;
      }
      if (this.doSave || this.doUpdate) {
        try {
          const uuid = uuidv4();
          this.contactPerson.uuid = uuid;

          const { data } = await this.$store.dispatch(PUT, {
            url: `leads/${this.leadId}/contact-person`,
            data: { persons: [this.contactPerson] },
          });

          this.contactPerson = this.lodash.find(data, { uuid });
          this.contactPersons = data;
          this.$emit("input", this.contactPersons);
          this.$emit("update:person", this.contactPerson);
        } catch (error) {
          this.logError(error);
          return;
        }
      } else {
        this.contactPersons.push({ ...this.contactPerson, id: null });
        this.$emit("input", this.contactPersons);
      }

      this.resetForm();
      this.$emit("close", true);
    },
  },
  components: {
    Dialog,
    PhoneTextField,
    ManageCustomerdesignation,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 60);
    },
  },
  mounted() {
    this.initComponent();
    this.setOptions();
  },
};
</script>
